var mix = function (from, to, progress) {
    return -progress * from + progress * to + from;
};

export { mix };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/node_modules/popmotion/dist/es/utils/mix.js
// module id = 31
// module chunks = 0